import { gql } from '@apollo/client';

export default gql`
  subscription eventChange {
    eventChange {
      data
      userId
      time
    }
  }
`;
